export enum DosingResponsibilityAgreementType {
  EmptyLotsResponsibilityDisclaimer = 'empty_lots_responsibility_disclaimer',
  DosingResponsibilityDisclaimer = 'dosing_responsibility_disclaimer',
  kbResponsibilityDisclaimer = 'kb_responsibility_disclaimer',
}
